import { Link, LinkProps } from '@mui/material';
import { primaryColors } from 'config/defaultTheme';

export default function ButtonLink({ sx, ...restProps }: LinkProps) {
  return (
    <Link
      component="button"
      variant="body2"
      sx={{
        color: primaryColors.electricBerry,
        fontSize: '1rem',
        fontWeight: 'normal',
        textDecoration: 'underline',
        textTransform: 'lowercase',
        ...sx,
      }}
      {...restProps}
    />
  );
}
